<div *ngIf="showCommentCounter && commentCount" class="comment-counter">
    <div><span class="hs-icon-arrow-down"></span> {{ commentCount }}</div>
</div>
